/* Built In Imports */
/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import SimpleButtonV2 from '@msr/components/Buttons/SimpleButtonV2';
import StructuredTextParser from '@msr/Utility/StructuredTextParser';
import { useEffect } from 'react';

/* Services */

/**
 * Renders the Attend In Person Banner Section component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for the Section
 * @param {string} lang - Language for the Section
 * @returns {ReactElement} - AttendInPersonBanner Section Component
 */

export const AttendInPersonBanner = ({ section, lang }) => {
  // consoleLog('AttendInPersonBanner', section);
  let isLgScreen = useMediaQuery({minWidth : 1024})

  const handleScroll = () => {
    const element = document.getElementById('seating-layout-section');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' }); // 'smooth' enables animated scrolling
    }
  };

  useEffect(() => {        
    if(isLgScreen){
      window.addEventListener('scroll', function() {
        const container = document.getElementById('bannerBtn');
        const fixedBtn = document.getElementById('fixedBtnDesktop');
        const rect = container.getBoundingClientRect();
        if (rect.bottom < 0) {
          // bannerBtn is completely out of view (above)
          fixedBtn.style.display = 'block';
        } else {
          // bannerBtn is at least partially visible
          fixedBtn.style.display = 'none';
        }
      });      
    }
    else {
      window.addEventListener('scroll', function () {
        const container = document.getElementById('bannerBtn');
        const fixedBtn = document.getElementById('fixedBtnMob');
        const rect = container.getBoundingClientRect();
        if (rect.bottom < 0) {
          // bannerBtn is completely out of view (above)
          fixedBtn.style.display = 'flex';
        } else {
          // bannerBtn is at least partially visible
          fixedBtn.style.display = 'none';
        }
      });
    }
  }, [])


  return (
    <Box
      // mb={{base:'1rem', md:'3rem'}}
      backgroundImage={{
        base: section.sectionContent[0]?.mobileImage?.url,
        sm: section.sectionContent[0]?.image?.url,
      }}
      bgSize={{ base: 'contain', sm: 'cover', xl: 'contain' }}
      bgColor="#000"
      bgPos={{ base: '0px -70px', lg: '45px center', '2xl': '70% center' }}
      bgRepeat="no-repeat"
      width="100%"
      position="relative"
      height={{ base: 'auto', sm: '663px' }}
      display="flex"
      flexDir="column"
      justifyContent="center"
      _before={{
        lg: {
          position: 'absolute',
          height: '100%',
          width: '50%',
          zIndex: 0,
          content: '""',
          background:
            'linear-gradient(90deg, #000000 43.45%, rgba(0, 0, 0, 0) 100%)',
        },
      }}
      _after={{
        lg: {
          position: 'absolute',
          height: '100%',
          width: '20%',
          zIndex: 0,
          right: 0,
          content: '""',
          background:
            'linear-gradient(270deg, #000000 43.45%, rgba(0, 0, 0, 0) 100%)',
        },
        sm: {
          position: 'absolute',
          height: '100%',
          // width: '30%',
          zIndex: 0,
          right: 0,
          content: '""',
          background:
            'linear-gradient(270deg, #000000 43.45%, rgba(0, 0, 0, 0) 100%)',
        },
      }}
    >
      <Box className="" maxW={'1920px'} >
        <Box
          display={{ base: 'block', md: 'none' }}
          // backgroundImage={{
          //   base: `${config.imgPath}/d/46272/1663039969-attend-in-person-mbe.jpg`,
          //   sm: 'none',
          // }}
          position="relative"
          height={{ base: '328px', sm: 'auto' }}
          backgroundSize="cover"
          backgroundPosition="center"
          _after={{
            base: {
              /*  background: 'linear-gradient(360deg, black, transparent)',
              position: 'absolute', */
              width: '100%',
              height: '114px',
              left: '0',
              top: '214px',
              content: '" "',
              zIndex: 2,
            },
            sm: {
              background: 'none !important',
            },
          }}
        />
        <Box
          maxW={{ base: '100%', sm: '56%', md: '420px', lg: '460px' }}
          position="relative"
          zIndex={1}
          ml={{ base: 'auto', md: '15px', lg: '150px', '2xl': '250px' }}
          mt={{ base: '-40px', lg: '-70px' }}
          height={{ base: "410px", md: 'auto' }}
        >
          <Heading
            as="h1"
            mb={{ base: '10px', md: '30px' }}
            fontFamily="FedraSansStd-A-medium"
            fontStyle="normal"
            fontWeight="500"
            fontSize={
              lang == 'ta'
                ? { base: '26px', md: '30px' }
                : { base: '24px', md: '36px', lg: '40px' }
            }
            color="#FFF7E9"
            mx={{ base: '30px', md: '0px' }}
            lineHeight={{ lg: '120%' }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            {section?.sectionContent[1]?.text}
          </Heading>

          <Heading
            as="h4"
            fontFamily="FedraSansStd-medium"
            fontStyle="normal"
            fontWeight="500"
            fontSize={
              lang == 'ta'
                ? { base: '20px', md: '18px' }
                : { base: '18px', md: '18px', lg: '26px' }
            }
            color="#FFA735"
            mb={{ base: '20px', md: '30px' }}
            lineHeight={{ lg: '170%' }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            {section?.sectionContent[3]?.text} <br />
            {section?.sectionContent[2]?.text}
          </Heading>
          <Text
            // as="p"
            fontFamily="FedraSansStd-book"
            fontStyle="normal"
            fontWeight={{ base: '400', md: '500' }}
            color="#D6D6D6"
            mb={{ base: '10px', md: '30px' }}
            maxW={{ base: '100%', md: '70%' }}
            sx={{
              p: {
                fontSize: lang == 'ta' ? { base: '14px' } : { base: '16px' },
              },
            }}
            lineHeight={{ lg: '150%' }}
            textAlign={{ base: 'center', md: 'left' }}
            mx={{ base: '3.5rem', md: '0px' }}
          >
            <StructuredTextParser
              str={render(section?.sectionContent[4]?.body)}
              bgTheme="light"
              color="#D6D6D6" m={'0px'} p={'0px'}
              textAlign={{ base: 'center', md: 'left' }}
            />
          </Text>
          {/* <SimpleButton
            bg="#FFA735"
            color="#000"
            fontSize="16px"
            fontFamily="FedraSansStd-book"
            mb="10px"
            padding=" 18px 20px"
            display="flex"
            flexDirection="column"
            alignItems=" flex-start"
            height="56px"
            _hover={{
              backgroundColor: 'none',
            }}
          >
            {section?.sectionContent[5]?.buttonText}
          </SimpleButton> */}
          <Box id='bannerBtn' display={{ base: 'flex', md: 'block' }}>
            <SimpleButtonV2
              style={section?.sectionContent[5]}
              region={''}
              lang={lang}
              w={'149px'}
              lineHeight={"56px"}
              mb="10px"
              clickHandler={e => {
                e.preventDefault()
                handleScroll()
              }}
            />
          </Box>
          <Text
            as="p"
            fontFamily="FedraSansStd-book"
            fontStyle="italic"
            fontWeight="400"
            fontSize="16px"
            color="#fff"
            mb="30px"
            sx={{
              fontSize: lang == 'ta' ? { base: '14px' } : { base: '16px' },
            }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            {section?.sectionContent[6]?.text}
          </Text>

          <Text
            as="p"
            fontFamily="FedraSansStd-book"
            fontStyle="normal"
            fontWeight=" 500"
            fontSize="16px"
            color="#fff"
            maxW={{ base: '100%', md: '70%' }}
            pb={{ base: '38px', md: 'inherit' }}
          >
            {section?.sectionContent[7]?.text}
          </Text>
        </Box>
      </Box>

      
      <Box id='fixedBtnDesktop' display={'none'} position={'fixed'} top={"20rem"} zIndex={1000} right={'0px'} >
        <SimpleButtonV2
          borderRadius={"5px 0px 0px 5px"}
          style={section?.sectionContent[5]}
          bType={section?.sectionContent[5]?.sectionId}
          width={'152px'}
          height={'91px'}
          lineHeight={'30px'}
          padding={'18px'}
          fontSize={'24px'}
          clickHandler={e => {
            e.preventDefault()
            handleScroll()
          }}
        />
      </Box>
      <Box width={'100%'} id='fixedBtnMob' position={'fixed'} display={'none'} bg={'#23285F'} justifyContent={'center'} h={'78px'} alignItems={'center'} bottom={'0'}
        zIndex={1000} pt={'20px'}>
        <SimpleButtonV2
          style={section?.sectionContent[5]}
          bType={section?.sectionContent[5]?.sectionId}
          w={'149px'}
          clickHandler={e => {
            e.preventDefault()
            handleScroll()
          }}
        />
      </Box>
    </Box>
  );
};
